<template>
	<ClassifyContent
		:initial-company-id="companyId"
		:is-child-site="isChildSite"
		:initial-productnature="productnature"
	/>
</template>

<script setup>
import { watch } from 'vue';
import ClassifyContent from '@/pages/category/CategoryContent.vue';
import { queryWebsiteByCompanyId } from '@/api/index.js';
import { buildCategoryPath, isMainCompany } from '#shared/categoryRoutes';

definePageMeta({
	keepalive: true,
});

const route = useRoute();
const companyId = computed(() => route.params.companyId ?? '1');
const categoryProductnature = useCategoryProductnature(route.params.productnature ? String(route.params.productnature) : null);
const productnature = computed(() => categoryProductnature.value);
const isChildSite = computed(() => !isMainCompany(companyId.value));

watch(
	() => route.params.productnature,
	value => {
		categoryProductnature.value = value ? String(value) : null;
	},
	{ immediate: true }
);

if (!isChildSite.value) {
	await navigateTo(buildCategoryPath(1, productnature.value), { redirectCode: 301 });
}

const { data: websiteInfo } = await useAsyncData(
	() => `website-classify-${companyId.value}`,
	() => queryWebsiteByCompanyId(companyId.value),
	{ watch: [companyId] }
);

const companyFullName = computed(() => {
	const site = websiteInfo.value?.data;
	return site?.fullName || site?.companyName || site?.websiteName || '国械在线';
});
const seoCompanyName = computed(() => (isChildSite.value ? companyFullName.value : '国械在线'));
const province = computed(() => {
	const site = websiteInfo.value?.data;
	return site?.province || site?.provinceName || site?.provinceStr || site?.provincename || '';
});
const childTitle = computed(() => `全部商品分类 - ${seoCompanyName.value}`);
const childKeywords = computed(() => `全部商品分类,${seoCompanyName.value}`);
const childDescription = computed(() =>
	`${seoCompanyName.value}官方平台商品分类导航页，提供医疗器械、医用耗材等全品类类目索引，支持医院、药店及及企业客户快速定位采购需求，服务${province.value || '所属省级行政区'}地区。`
);
useHead(() => {
	return {
		title: childTitle.value,
		meta: [
			{ name: 'description', content: childDescription.value, tagPriority: 10 },
			{ name: 'keywords', content: childKeywords.value, tagPriority: 10 },
		],
	};
});
</script>
